import User from "@phoenixreisen/user";
import React from "react";
const Footer = () => {
    User.load();
    return (React.createElement("article", { className: "intern-footer" },
        React.createElement("div", { className: "wrapper wrapper--large" },
            React.createElement("hr", null),
            User.isLoggedIn() && (React.createElement("div", { className: "tr mr3" },
                React.createElement("span", null,
                    "eingeloggt als",
                    " ",
                    React.createElement("span", { className: "f4" }, User.getPhxUsername() || "")),
                React.createElement("span", { className: "mh3" }, "|"),
                React.createElement("a", { href: "/cdn/mitarbeiter/login/" },
                    React.createElement("i", { className: "fas fa-sign-out-alt mr1" }),
                    " abmelden"))),
            !User.isLoggedIn() && (React.createElement("div", { className: "tr mr3" },
                React.createElement("a", { href: "/cdn/mitarbeiter/login/" },
                    React.createElement("i", { className: "fas fa-sign-in-alt mr1" }),
                    " anmelden"))))));
};
export default Footer;
